import React, { useState, useEffect } from "react";
import OrderHeaders from "./orderHeader/OrderHeaders";
import "./OrderPageIntegration.css";
import CatagoriesOrder from "./CatagoriesOrder/CatagoriesOrder";
import TableIntegration from "./TableIntegration";
import api from "../../../services/api";
import CompletedCancelationnTable from "./CompletedCancelationnTable";
import { useDispatch, useSelector } from "react-redux";
import { addOrder, clearRestaurantData } from "../../../redux/Slice/OrderSlice";
import { clearTokens, getAccessToken } from "../../../auth/AuthHandler";
import { useNavigate } from "react-router-dom";
import { SELECTED_RESTAURANT_ID_KEY, SELECTED_RESTAURANT_NAME_KEY } from "../../../services/constants";
import OrderSkeleton from "./OrderSkeleton";

function OrderPageIntegration({ completedDataLoading = () => {}, lodaingState = false, onBack }) {
  const [activeCategory, setActiveCategory] = useState("Take Away");
  const [searchQuery, setSearchQuery] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [orders, setOrders] = useState([]);
  const orderStored = useSelector((state) => state.order.orders);
  const [inProgressTakeAway, setInProgressTakeAway] = useState(0);
  const [inProgressDineIn, setInProgressDineIn] = useState(0);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectTitleForCompletedCancelled, setSelectTitleForCompletedCancelled] = useState("TakeAway");
  const [isLoading, setIsLoading] = useState(true);

  const fetchOrders = async () => {
    const token = getAccessToken();
    if (!token) {
      clearTokens();
      return;
    }

    try {
      const response = await api.get(`/restaurant-management/orders/takeaway`);
      setOrders(response.data.orders || []);
      dispatch(addOrder(response.data.orders || []));
      setIsLoading(false);
      completedDataLoading();
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
    setRefresh(false);
  };

  useEffect(() => {
    if (orderStored.length === 0) {
      fetchOrders();
    } else {
      setIsLoading(false);
      if (lodaingState) {
        completedDataLoading();
      }
    }
  }, [lodaingState]);

  useEffect(() => {
    setOrders(orderStored);

    const inProgressStatuses = ["Preparing", "Ready", "Delayed", "Check In"];

    setInProgressDineIn(
      orderStored.filter(
        (order) => order.orderType === "Dine-in" && inProgressStatuses.includes(order.user.orderStatus)
      ).length
    );

    setInProgressTakeAway(
      orderStored.filter(
        (order) => order.orderType === "Takeaway" && inProgressStatuses.includes(order.user.orderStatus)
      ).length
    );

    completedDataLoading();
  }, [orderStored, refresh]);

  const handleRefresh = () => {
    setRefresh(true);
    fetchOrders();
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  useEffect(() => {
    if (!searchQuery) {
      setActiveCategory("Take Away");
      return;
    }

    const matchingOrders = orders.filter((order) =>
      String(order.id || "").toLowerCase().includes(searchQuery.toLowerCase())
    );

    const noShowOrders = matchingOrders.filter((order) => order.user.orderStatus === "No-Show");
    const cancelledOrders = matchingOrders.filter((order) => order.user.orderStatus === "Cancelled");
    const completedOrders = matchingOrders.filter((order) => order.user.orderStatus === "Completed");

    if (noShowOrders.length > 0) {
      setActiveCategory("No Show");
      setSelectTitleForCompletedCancelled(
        noShowOrders.some((order) => order.orderType === "Dine-in") ? "DineIn" : "TakeAway"
      );
      return;
    }

    if (cancelledOrders.length > 0) {
      setActiveCategory("Cancelled");
      setSelectTitleForCompletedCancelled(
        cancelledOrders.some((order) => order.orderType === "Dine-in") ? "DineIn" : "TakeAway"
      );
      return;
    }

    if (completedOrders.length > 0) {
      setActiveCategory("Completed");
      setSelectTitleForCompletedCancelled(
        completedOrders.some((order) => order.orderType === "Dine-in") ? "DineIn" : "TakeAway"
      );
      return;
    }

    setActiveCategory(
      matchingOrders.some((order) => order.orderType === "Dine-in") ? "Dine in" : "Take Away"
    );
  }, [searchQuery, orders]);

  const getReorderedOrders = () => {
    if (!searchQuery) return orders;
    return orders.filter((order) => String(order.id || "").includes(searchQuery));
  };

  const onSelectCategory = (category) => {
    setActiveCategory(category);
    setSelectTitleForCompletedCancelled("TakeAway");
  };

  const handleBack = () => {
    dispatch(clearRestaurantData());
    localStorage.removeItem(SELECTED_RESTAURANT_ID_KEY);
    localStorage.removeItem(SELECTED_RESTAURANT_NAME_KEY);
    if (onBack) onBack();
    else navigate("/BOD/restaurant-management");
  };

  if (isLoading) {
    return <OrderSkeleton />;
  }

  return (
    <div className="OrdersContent">
      <OrderHeaders
        searchQuery={searchQuery}
        handleSearchChange={handleSearchChange}
        onBack={handleBack}
      />
      <div className="catagoreisOrders">
        <CatagoriesOrder
          activeCategory={activeCategory}
          onSelectCategory={onSelectCategory}
          requestTakeAway={inProgressTakeAway}
          requestDineIn={inProgressDineIn}
        />
      </div>

      {(activeCategory === "Completed" || activeCategory === "Cancelled" || activeCategory === "No Show") && (
        <div className="RequestInprogress">
          <h5
            className={`SelectTitleProgress ${selectTitleForCompletedCancelled === "TakeAway" ? "active" : ""}`}
            onClick={() => setSelectTitleForCompletedCancelled("TakeAway")}
          >
            Take Away
          </h5>
          <h5
            className={`SelectTitleProgress ${selectTitleForCompletedCancelled === "DineIn" ? "active" : ""}`}
            onClick={() => setSelectTitleForCompletedCancelled("DineIn")}
          >
            Dine In
          </h5>
        </div>
      )}

      <div className="horLine"></div>

      {activeCategory === "Take Away" || activeCategory === "Dine in" ? (
        <TableIntegration orderType={activeCategory} orderData={getReorderedOrders()} refresh={handleRefresh} />
      ) : (
        <CompletedCancelationnTable
          selectTitle={activeCategory}
          orderType={selectTitleForCompletedCancelled}
          orderData={getReorderedOrders()}
          refresh={handleRefresh}
        />
      )}
    </div>
  );
}

export default OrderPageIntegration;

